<template>
  <loader v-if="loading"></loader>
  <load-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :cancel-button="true"
    :remove-button="$route.params.id !== 'new' && instance.permissions.delete"
    :edit-button="!editing && instance.permissions.update"
    :save-button="editing"
    remove-confirm-message="Vuoi veramente eliminare questa analisi?"
    @cancel="cancel"
    @remove="remove"
    @edit="edit"
    @save="save">
    <context-manager
      context="analyses"
      :contextId="instance.id"
      :permissions="instance.permissions"
      :workgroupId="instance.workgroup.id"
      open
      v-if="instance && instance.id" />
    <analysis
      ref="editor"
      :value="instance"
      :errors="errors"
      :disabled="!editing"
      @input="instance = $event"
    />
    <div
      v-if="!editing"
      slot="bottom"
      class="row">
      <b-col md="4">
        <router-link-card
          :to="{ name: 'XbrlAnalyses', params: { analysisId: instance.id } }"><!--:disabled="!r.permissions.load"-->
          <div slot="header" class="font-weight-bold">
            Analisi bilancio
          </div>
          Modulo di analisi di dati di bilancio in input da file xbrl e/o
          inseriti manualmente.
        </router-link-card>
      </b-col>
      <b-col md="4">
        <router-link-card
          :to="{ name: 'CrAnalyses', params: { analysisId: instance.id } }"><!--:disabled="!r.permissions.load"-->
          <div slot="header" class="font-weight-bold">
            Analisi CR
          </div>
          Modulo di analisi di dati della centrale rischi della Banca d'Italia
          in input da file pdf ufficiale.
        </router-link-card>
      </b-col>
      <b-col md="4">
        <router-link-card
          :to="{ name: 'CrifAnalyses', params: { analysisId: instance.id } }"><!--:disabled="!r.permissions.load"-->
          <div slot="header" class="font-weight-bold">
            Analisi Crif
          </div>
          Modulo di analisi di dati della centrale rischi della Crif
          in input da file pdf ufficiale.
        </router-link-card>
      </b-col>
    </div>
    <debug-panel slot="debug">{{ instance }}</debug-panel>
  </load-page-layout>
</template>
<script>
import AnalysisService from 'app/services/AnalysisService';
import LoadPageMixin from 'vue-core/mixins/LoadPageMixin';

export default {
  mixins: [ LoadPageMixin ],

  created() {
    this.service = AnalysisService;
  },

  computed: {
    breadcrumbs() {
      if (!this.instance) {
        return [];
      }

      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Analisi',
          link: '/protected/analyses'
        },
        {
          label: this.$route.params.id === 'new'
              ? '<Nuova>'
              : (this.instance && this.instance.title || '<Analisi>')
        }
      ];
    },
  },

  methods: {
    /*
    save() {
      if (this.$refs.editor.dirtyInput) {
        const msg = 'ATTENZIONE: il software ha rilevato dei dati modificati. '
          + 'Procedendo al salvataggio senza effettuare una nuova analisi, '
          + 'i dati andranno persi. Sei sicuro di voler procedere?';

        if (!confirm(msg)) {
          return;
        }
      }

      if (this.$route.params.id !== 'new') {
        this.update();
      } else {
        this.insert();
      }
    },
    */

    cancel() {
      if (!this.instance.id || !this.editing) {
        this.$router.push({
          name: 'Analyses'
        });
      } else {
        this.unedit();
      }
    },

    onRemoveSuccess({ statusCode, data}) {
      this.$router.push({
        name: 'Analyses'
      });
    },
  }
};
</script>
